import React from 'react';
import { useNavigate, useLocation, useSearchParams } from 'react-router-dom';
import { clearMyDataDraft } from '../utils/myDataDraft';

const TITLES = {
  fetching: '데이터 수집 중 오류가 발생했습니다',
};

const REASONS = {
  timeout: '요청 시간이 초과되었습니다. 다시 시도해주세요.',
  network: '네트워크 연결을 확인하고 다시 시도해주세요.',
  server: '서버에 일시적인 문제가 발생했습니다. 잠시 후 다시 시도해주세요.',
  unknown: '알 수 없는 오류가 발생했습니다. 다시 시도해주세요.',
};

export default function MyDataErrorPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const [params] = useSearchParams();
  const basePath = location.pathname.startsWith('/app') ? '/app' : '';
  const phase = params.get('phase') || 'fetching';
  const reason = params.get('reason') || 'unknown';

  return (
    <div
      role="alert"
      aria-labelledby="mydata-error-title"
      aria-describedby="mydata-error-description"
      style={{ maxWidth: 720, margin: '0 auto', padding: '60px 16px', textAlign: 'center' }}
    >
      <div style={{ fontSize: 56, marginBottom: 16 }} aria-hidden="true">⚠️</div>
      <h1 id="mydata-error-title" className="page-title" aria-live="assertive">{TITLES[phase] || TITLES.fetching}</h1>
      <p id="mydata-error-description" className="page-description" style={{ marginBottom: 32 }}>{REASONS[reason] || REASONS.unknown}</p>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 10, maxWidth: 360, margin: '0 auto' }}>
        <button type="button" className="submit-button"
          onClick={() => navigate(basePath + '/mydata/connect/' + phase)}
          style={{ width: '100%', padding: '14px 0', fontSize: 16 }}>
          다시 시도
        </button>
        <button type="button"
          onClick={() => { clearMyDataDraft(); navigate(basePath + '/mydata/connect/consent'); }}
          style={{
            width: '100%', padding: '12px 0', fontSize: 15,
            background: '#fff', border: '1px solid #e5e7eb', borderRadius: 8,
            color: '#4b5563', cursor: 'pointer',
          }}>
          처음부터 다시
        </button>
        <button type="button"
          onClick={() => { clearMyDataDraft(); navigate(basePath + '/analysis'); }}
          style={{
            width: '100%', padding: '12px 0', fontSize: 15,
            background: '#fff', border: '1px solid #e5e7eb', borderRadius: 8,
            color: '#4b5563', cursor: 'pointer',
          }}>
          처음으로 돌아가기
        </button>
      </div>
    </div>
  );
}
